import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const FOOTER_COLUMNS = [
  { key: 'prodotto',   links: [{ key: 'home', href: '/' }, { key: 'soluzioni', href: '/soluzioni' }, { key: 'pricing', href: '/pricing' }, { key: 'vsChatgpt', href: '/vs-chatgpt' }, { key: 'mcp', href: '/mcp' }, { key: 'multilingual', href: '/multilingual' }] },
  { key: 'guide',      links: [{ key: 'landing', href: '/guide' }, { key: 'leggereSentenza', href: '/guide/leggere-una-sentenza' }, { key: 'massimaSentenza', href: '/guide/massima-e-sentenza' }, { key: 'quandoServeAvvocato', href: '/guide/quando-serve-avvocato' }, { key: 'cassazione', href: '/guide/cassazione-come-funziona' }] },
  { key: 'developers', links: [{ key: 'landing', href: '/developers' }, { key: 'mcp', href: '/developers/mcp' }, { key: 'api', href: '/developers/api' }, { key: 'cli', href: '/developers/cli' }, { key: 'faq', href: '/developers/faq' }] },
  { key: 'legali',     links: [{ key: 'terms', href: '/terms' }, { key: 'privacy', href: '/privacy' }] },
] as const

export default function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="bg-muted py-12 mt-20" data-testid="site-footer">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.key}>
              <h4 className="text-sm font-semibold uppercase text-muted-foreground mb-3">
                {t(`common.footer.${col.key}.title`)}
              </h4>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.key}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground/80 hover:text-primary"
                    >
                      {t(`common.footer.${col.key}.items.${link.key}`)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-muted-foreground mt-8">{t('common.footer.copyright')}</p>
        <p className="text-center text-xs text-muted-foreground mt-2">
          {t('common.footer.dataFrom')}{' '}
          <a
            href="https://www.normattiva.it"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-foreground"
          >
            Normattiva.it
          </a>{' '}
          {t('common.footer.underLicense')}{' '}
          <a
            href="https://www.dati.gov.it/iodl/2.0"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-foreground"
          >
            IODL 2.0
          </a>
        </p>
      </div>
    </footer>
  )
}